import { render } from "./sceneDesignMainHeader.vue?vue&type=template&id=5e375dc0&scoped=true&ts=true&lang=pug"
import script from "./sceneDesignMainHeader.vue?vue&type=script&lang=ts"
export * from "./sceneDesignMainHeader.vue?vue&type=script&lang=ts"

import "./sceneDesignMainHeader.vue?vue&type=style&index=0&id=5e375dc0&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e375dc0"]])

export default __exports__